import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';
import { TokenService } from '../../services/token.service';
import { AuthService } from '../../services/auth.service';
import { CommonModule } from '@angular/common';
import { MeService } from '../../services/me.service';
import { UserProfile } from '../../models/user-profile.model';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-bar',
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    RouterModule,
    CommonModule,
  ],
  templateUrl: './nav-bar.component.html',
  styleUrl: './nav-bar.component.scss',
})
export class NavBarComponent implements OnInit {
  adminName: string = '';
  selectedValue: string = '';
  pageName: string = '';
  links = [
    { label: 'Home', route: '/home' },
    { label: 'Admins', route: '/admins' },
    { label: 'Vendors', route: '/vendors' },
    { label: 'Users', route: '/users' },
    { label: 'Posts', route: '/posts' },
    { label: 'Colleges', route: '/colleges' },
    { label: 'Campuses', route: '/campuses' },
    { label: 'My Account', route: '/account-info' },
  ];

  constructor(
    private tokenService: TokenService,
    private authService: AuthService,
    private router: Router,
    private meService: MeService
  ) {}

  ngOnInit(): void {
    this.meService.getMyUserProfile().subscribe({
      next: (response: UserProfile) => {
        this.adminName = response.user.firstName + ' ' + response.user.lastName;
      },
    });
    this.getPathName();
  }

  getPathName() {
    const name = this.router.url.split('/')[1];
    this.pageName = name[0].toUpperCase() + name.substr(1).toLowerCase();
  }

  routeClick(label: string, route: string) {
    this.router.navigate([route]);
    this.pageName = label;
  }

  getAvatarUrl(): string {
    const encodedName = encodeURIComponent(this.adminName);
    return `https://ui-avatars.com/api/?name=${encodedName}&rounded=true&color=FFFFFF&background=FB6A00`;
  }

  logout() {
    this.authService.loggedIn = false;
    this.tokenService.logout();
  }
}
